import { render } from "./Del.vue?vue&type=template&id=35355838&scoped=true&ts=true"
import script from "./Del.vue?vue&type=script&lang=ts"
export * from "./Del.vue?vue&type=script&lang=ts"

import "./Del.vue?vue&type=style&index=0&id=35355838&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35355838"]])

export default __exports__